/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  /* CUSTOM CODE ECHT JETZT: DELIVERY DATE */
  function updateLieferdatum() {
    fetch("/cart")
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newBlock = doc.querySelector("#lieferdaten-wrapper");
        const currentBlock = document.querySelector("#lieferdaten-wrapper");
        if (newBlock && currentBlock) {
          currentBlock.replaceWith(newBlock);
          const activeMethod = document.querySelector(
            ".checkoutMethod.active .checkoutMethodName"
          );
          const isShipping =
            activeMethod &&
            activeMethod.textContent.trim().toLowerCase() === "versand";
          newBlock.style.display = isShipping ? "block" : "none";
        }
      });
  }

  const observer = new MutationObserver(() => {
    updateLieferdatum();
  });

  const waitForDrawer = setInterval(() => {
    const drawer = document.querySelector("#cart-drawer");
    if (drawer) {
      clearInterval(waitForDrawer);
      observer.observe(drawer, { childList: true, subtree: true });
      updateLieferdatum();
    }
  }, 200);

  function toggleLieferzeitBlock() {
    const activeMethod = document.querySelector(
      ".checkoutMethod.active .checkoutMethodName"
    );
    const lieferBlock = document.querySelector("#lieferdaten-wrapper");
    if (!activeMethod || !lieferBlock) return;
    const isShipping =
      activeMethod.textContent.trim().toLowerCase() === "versand";
    lieferBlock.style.display = isShipping ? "block" : "none";
  }

  document.addEventListener("DOMContentLoaded", toggleLieferzeitBlock);

  document.addEventListener("click", function (e) {
    if (e.target.closest(".checkoutMethod")) {
      setTimeout(toggleLieferzeitBlock, 100);
    }
  });
  /* END OF CUSTOM CODE ECHT JETZT: DELIVERY DATE */

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
